import { defineComponent as u, useSlots as f, openBlock as o, createBlock as l, unref as e, normalizeClass as c, withCtx as i, createElementVNode as y, createElementBlock as m, createVNode as p, renderSlot as n, createCommentVNode as d } from "vue";
import k from "./ghl-ui.es229.js";
import h from "./ghl-ui.es230.js";
import v from "./ghl-ui.es181.js";
import "./ghl-ui.es13.js";
import "./ghl-ui.es231.js";
import $ from "./ghl-ui.es174.js";
import b from "./ghl-ui.es232.js";
import w from "./ghl-ui.es121.js";
const C = { class: "body" }, S = {
  key: 2,
  class: "mt-3"
}, A = u({
  name: "UIAlert",
  inheritAttrs: !1
}), B = u({
  ...A,
  props: {
    id: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "default"
    },
    closable: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close"],
  setup(t) {
    const s = f();
    return (r, a) => (o(), l(e(b), {
      id: t.id,
      type: t.type,
      closable: t.closable,
      class: c(["rounded-[12px]", [`hl-${t.type}`]]),
      onClose: a[0] || (a[0] = () => r.$emit("close", t.id))
    }, {
      icon: i(() => [
        t.type === "warning" ? (o(), l(e(k), {
          key: 0,
          class: "w-5 h-5"
        })) : t.type === "success" ? (o(), l(e(h), {
          key: 1,
          class: "w-5 h-5"
        })) : (o(), l(e(v), {
          key: 2,
          class: "w-5 h-5"
        }))
      ]),
      default: i(() => [
        y("div", C, [
          e(s).title ? (o(), m("div", {
            key: 0,
            class: c(e(s).content || e(s).actions ? "title" : "")
          }, [
            p(e(w), null, {
              default: i(() => [
                n(r.$slots, "title", {}, void 0, !0)
              ]),
              _: 3
            })
          ], 2)) : d("", !0),
          e(s).content ? n(r.$slots, "content", { key: 1 }, void 0, !0) : d("", !0),
          e(s).actions ? (o(), m("div", S, [
            n(r.$slots, "actions", {}, void 0, !0)
          ])) : d("", !0)
        ])
      ]),
      _: 3
    }, 8, ["id", "type", "closable", "class"]));
  }
}), M = /* @__PURE__ */ $(B, [["__scopeId", "data-v-1cd95d1d"]]);
export {
  M as default
};
